import { render, staticRenderFns } from "./NotificationPanelList.vue?vue&type=template&id=8147bbb8&"
import script from "./NotificationPanelList.vue?vue&type=script&lang=js&"
export * from "./NotificationPanelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8147bbb8')) {
      api.createRecord('8147bbb8', component.options)
    } else {
      api.reload('8147bbb8', component.options)
    }
    module.hot.accept("./NotificationPanelList.vue?vue&type=template&id=8147bbb8&", function () {
      api.rerender('8147bbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/notifications/components/NotificationPanelList.vue"
export default component.exports